import React from 'react';
import { Row, Col, ProgressBar } from 'react-bootstrap';
import { getOverAllRating } from '../../utils/utils';

function StarRow({ stars, percent }) {
    return (
        <Row className="align-items-center mb-1">
            <Col md={8} xs={3}>
                <ProgressBar
                    now={percent}
                    style={{ height: '8px', background: '#e9ecef' }}
                    variant="dark"
                />
            </Col>
            <Col md={3} xs={7} className="text-end p-0">
                {getOverAllRating(stars, { fontSize: '1.2rem', marginRight: '16px' })}
            </Col>
            <Col md={1} xs={2} className="text-start p-0" style={{ fontSize: '0.95rem', color: '#2125298f' }}>
                {percent}%
            </Col>
        </Row>
    );
}

function Rating ({courseRatingSummary}) {
    return (
        <div>
            <h6 className="fw-600 mb-3">Participant Feedback</h6>
            <Row>
                <Col md={3} xs={12} className="text-center">
                    <div style={{ fontSize: '2.5rem', color: '#ff6600', fontWeight: 700 }}>{courseRatingSummary?.averageRating}</div>
                    <div>
                        {getOverAllRating(courseRatingSummary?.averageRating)}
                    </div>
                    <div style={{ color: '#ff6600', fontSize: '0.95rem' }}>({courseRatingSummary?.totalRatings} ratings)</div>
                </Col>
                {/* <Col md={9} xs={12}>
                    {courseRatingSummary?.ratingsBreakdown.map((item, idx) => (
                        <StarRow key={item.stars} stars={item.stars} percent={item.percent} />
                    ))}
                </Col> */}
            </Row>
        </div>
    )
}

export default Rating;
